import store from '@/store';
import Base from '@/modules/staging/Base';
import Dashboard from '@/modules/staging/Dashboard';
import Lawn from '@/modules/staging/Lawn';
import Snow from '@/modules/staging/Snow';
import Startup from '@/modules/staging/Startup';
import Blowdown from '@/modules/staging/Blowdown';

const routes = [
  {
    path: '/staging/',
    component: Base,
    meta: { appKey: 'staging' },
    beforeEnter: (to, from, next) => {
        store.dispatch('clearSubnav')
        next()
    },
    children: [
      {
        path: 'dashboard/',
        component: Dashboard,
        name: 'StagingDashboard',
        
      },
      {
        path: 'lawn',
        component: Lawn,
        name: 'StagingLawn'
      },
      {
        path: 'snow/',
        component: Snow,
        name: 'StagingSnow',
      },
      {
        path: 'startup/',
        component: Startup,
        name: 'StagingStartup'
      },
      {
        path: 'blowdown/',
        component: Blowdown,
        name: 'StagingBlowdown'
      }
    ]
  }
]

export default routes
